module.exports = __webpack_public_path__ + "img/alarm-clock.30cccf39.svg";